var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4.71 7.71 7.3 10.3a1 1 0 0 0 1.41 0l2.59-2.59A1 1 0 0 0 10.59 6H5.41a1 1 0 0 0-.7 1.71"}})])}
var staticRenderFns = []

export { render, staticRenderFns }